import { useHasUserFeatures } from '#app/hooks/useHasUserFeatures.js';
import { UserGroup } from '@contra/graphql-types';

type ReferralProgramVariants = Extract<UserGroup, 'CLIENT_REFERRAL_PILOT'>;

export const useReferralLoopsFeatureFlag =
  (): null | ReferralProgramVariants => {
    const hasClientReferralPilotFeature = useHasUserFeatures(
      'CLIENT_REFERRAL_PILOT',
    );

    return hasClientReferralPilotFeature ? 'CLIENT_REFERRAL_PILOT' : null;
  };
